import { FieldDefinition } from './FieldDefinition';

export class GroupedField {
    constructor(field: FieldDefinition, fields: FieldDefinition[]) {
        this.sectionField = field;
        this.dependentFields = fields;
    }
    public sectionField: FieldDefinition;
    public dependentFields: FieldDefinition[];
}

export class PageField {
    constructor(field: FieldDefinition, fields: GroupedField[]) {
        this.pageField = field;
        this.dependentFields = fields;
    }
    public pageField: FieldDefinition;
    public dependentFields: GroupedField[];
}
